<template>
  <div
    style="position: absolute; bottom: 5px; right: 5px;"
  >
    <v-tooltip bottom>
      <template #activator="{ on, attrs }">
        <v-btn
          icon
          color="primary"
          v-bind="attrs"
          v-on="on"
          @click="copy_text()"
        >
          <v-icon>mdi-content-copy</v-icon>
        </v-btn>
      </template>
      <span>Copy Text</span>
    </v-tooltip>

    <v-tooltip bottom>
      <template #activator="{ on, attrs }">
        <v-btn
          icon
          color="primary"
          v-bind="attrs"
          v-on="on"
          @click="copy_html()"
        >
          <v-icon>mdi-code-tags</v-icon>
        </v-btn>
      </template>
      <span>Copy HTML</span>
    </v-tooltip>
  </div>
</template>

<script>
  import copy from 'copy-to-clipboard'

  export default {
    name: 'HomeSettings',

    data () {
      return {
      }
    },

    computed: {
    },
    methods: {
      rgbToHex (match, r, g, b) {
        return '#' + [r, g, b].map(x => {
          const hex = parseInt(x).toString(16)
          return hex.length === 1 ? '0' + hex : hex
        }).join('')
      },
      minifyHTML (html) {
        html = html
          .replace(/>\s+</g, '><')
          .replace(/\s{2,}/g, ' ')
          .replace(/<!--[\s\S]*?-->/g, '')
          .trim()

        return html.replace(/rgb\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)/g, this.rgbToHex)
      },
      copy_text () {
        const text = document.getElementById('abc')
        const selection = window.getSelection()
        const range = document.createRange()
        range.selectNodeContents(text)
        selection.removeAllRanges()
        selection.addRange(range)
        document.execCommand('copy')
        alert('Deine Signatur wurde in die Zwischenablage kopiert')
      },
      copy_html () {
        const salesForceHtml = document.getElementById('cba_sf').innerHTML
        copy(this.minifyHTML(salesForceHtml))
        // copy(salesForceHtml)
        alert('Deine Signatur wurde in die Zwischenablage kopiert')
      },
    },
  }
</script>
<style lang="scss">
.v-slide-group__content {
    justify-content: center;
  }
</style>
